export default "__VITE_ASSET__DkOdp2TW__"